import { computed } from 'vue';
import { useRoute } from 'vue-router';

export interface PopupCallbackMessage {
  source: string;
  type: string;
  data?: Record<string, unknown>;
}

export function useIsPopup (): ComputedRef<boolean> {
  const route = useRoute();
  return computed(() => route.query.popup === '1' && Boolean(window.opener));
}

export function usePopupCallback (source: string): {
  isPopup: ComputedRef<boolean>;
  send: (type: string, data?: Record<string, unknown>) => void;
  sendAndClose: (type: string, data?: Record<string, unknown>) => void;
} {
  const isPopup = useIsPopup();

  function send (type: string, data?: Record<string, unknown>): void {
    if (!window.opener) { return; }
    const message: PopupCallbackMessage = { source, type, data };
    window.opener.postMessage(message, '*');
  }

  function sendAndClose (type: string, data?: Record<string, unknown>): void {
    send(type, data);
    window.close();
  }

  return { isPopup, send, sendAndClose };
}
